/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RocketWarehouseUpdateReqVo
 */
export interface RocketWarehouseUpdateReqVo {
    /**
     * 火箭仓库编码
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    code?: string;
    /**
     * 仓库韩文名称
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    nameKr?: string;
    /**
     * 仓库中文名称
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    nameCn?: string;
    /**
     * 收货人名称
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    receiverName?: string;
    /**
     * 电话号码
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    mobileNo?: string;
    /**
     * 邮政编码
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    zip?: string;
    /**
     * 韩文地址
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    addressKr?: string;
    /**
     * 中文地址
     * @type {string}
     * @memberof RocketWarehouseUpdateReqVo
     */
    addressCn?: string;
    /**
     * 是否可用 0不可用 1可用
     * @type {number}
     * @memberof RocketWarehouseUpdateReqVo
     */
    enable?: number;
}

/**
 * Check if a given object implements the RocketWarehouseUpdateReqVo interface.
 */
export function instanceOfRocketWarehouseUpdateReqVo(value: object): value is RocketWarehouseUpdateReqVo {
    return true;
}

export function RocketWarehouseUpdateReqVoFromJSON(json: any): RocketWarehouseUpdateReqVo {
    return RocketWarehouseUpdateReqVoFromJSONTyped(json, false);
}

export function RocketWarehouseUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RocketWarehouseUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'nameKr': json['nameKr'] == null ? undefined : json['nameKr'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'receiverName': json['receiverName'] == null ? undefined : json['receiverName'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'addressKr': json['addressKr'] == null ? undefined : json['addressKr'],
        'addressCn': json['addressCn'] == null ? undefined : json['addressCn'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}

export function RocketWarehouseUpdateReqVoToJSON(json: any): RocketWarehouseUpdateReqVo {
    return RocketWarehouseUpdateReqVoToJSONTyped(json, false);
}

export function RocketWarehouseUpdateReqVoToJSONTyped(value?: RocketWarehouseUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'nameKr': value['nameKr'],
        'nameCn': value['nameCn'],
        'receiverName': value['receiverName'],
        'mobileNo': value['mobileNo'],
        'zip': value['zip'],
        'addressKr': value['addressKr'],
        'addressCn': value['addressCn'],
        'enable': value['enable'],
    };
}

